// extracted by mini-css-extract-plugin
export default {"noItems":"EmptyPage_noItems__xQmo8"};